// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loading_loaderContainer__gB0gC","title":"loading_title__Z-xNX","loader":"loading_loader__RIiUm"};